/** @jsx jsx */
import BackgroundImage from 'gatsby-background-image'
import {jsx} from 'theme-ui'
import { useStaticQuery } from "gatsby"
import Button from "../Button/button"
import IconButton from "../Button/IconButton"
import DarkOverlay from "../DarkOverlay/DarkOverlay"
// Icons
// import Dish from "../../icons/tools-kitchen-serving-dome.svg"
import Pickup from "../../icons/shopping-basket-smile.svg"
import Delivery from "../../icons/delivery-truck.svg"

const HeroContent = () => (
    <div sx={{
        position: 'relative',
        zIndex: 1
    }}>
        <h1 sx={{fontFamily: 'heading', fontSize:[5,6], lineHeight:'heading'}}>Welcome to <br/>the Silver Dragon</h1>
        <h2 sx={{fontSize: 3, fontWeight: 'body', mt: 4, mb: 5}}>The best Chinese food in San Francisco</h2>
        <div>
            {/* <a href="https://ehungry.com"><Button variant="primary"><IconButton><Pickup /></IconButton> Order Pickup</Button></a> */}
            <a href="https://ehungry.com"><Button variant="primary"><IconButton><Pickup /></IconButton> Order Pickup</Button></a>
            <a href="https://ehungry.com"><Button variant="primary" sx={{ml:[0,3,3], mt:[3,0,0]}}><IconButton><Delivery /></IconButton> Order Delivery</Button></a>
        </div>
    </div>
)

export default function Hero(props) {
    const data = useStaticQuery(graphql`
        query {
            file(sourceInstanceName: {eq: "backgrounds"}, name: {eq: "header"}) {
                childImageSharp {
                 fluid(quality:90, maxWidth:2560) {
                    ...GatsbyImageSharpFluid_withWebp
                 }
                }
            }
        }      
    `)
    const imageData = data.file.childImageSharp.fluid
    
    return (
        <BackgroundImage
        Tag="section"
        fluid={imageData}
        backgroundColor={`#040e18`}
        id={props.id}
        sx={{
            height: '100vh',
            minHeight: ['40rem', '47rem','47rem'],
            pt: '5rem',
            color: 'white',
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>   
            <DarkOverlay raggedTop={props.raggedTop} raggedBottom={props.raggedBottom} raggedTopColor={props.raggedTopColor} raggedBottomColor={props.raggedTopColor} />
            <HeroContent />
        </BackgroundImage>
    )
}